<script lang="ts">
  export let alignItems:
    | "flex-start"
    | "start"
    | "center"
    | "flex-end"
    | "end" = "flex-start";
  export let justifyContent:
    | "flex-start"
    | "center"
    | "flex-end"
    | "space-between" = "flex-start";
  export let direction: "row" | "row-reverse" | "column" | "column-reverse" =
    "row";
  export let directionMd:
    | "row"
    | "row-reverse"
    | "column"
    | "column-reverse"
    | null = null;
  export let noPadding = false;
  export let marginBottom = false;
  export let bgColor = "";
</script>

<div
  class={`grid-container  ${noPadding ? "no-padding" : ""} ${
    marginBottom ? "margin-bottom" : ""
  } ${$$restProps.class || ""} ${bgColor} ${
    bgColor !== "" ? "rounded-xl" : ""
  }`}
>
  <div
    class="flex row direction-{direction} direction-md-{directionMd
      ? directionMd
      : direction}"
    style="align-items: {alignItems}; justify-content: {justifyContent};"
  >
    <slot />
  </div>
</div>

<style lang="scss">
  .grid-container {
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap;

    &:not(.no-padding) {
      padding: 0 var(--grid-padding-mobile);

      @media screen and (min-width: 1024px) {
        padding: 0 calc(4rem - 20px);
      }

      @media screen and (min-width: 1280px) {
        padding: 0 calc(var(--grid-padding) - 20px);
      }
    }

    &.no-padding {
      @media screen and (max-width: 768px) {
        .row {
          margin: 0;
        }

        :global(.grid-item) {
          padding: 0;
        }
      }
    }

    &.margin-bottom {
      margin-bottom: fluid(120px);
    }

    .row {
      margin-left: calc(var(--grid-gutter) * -1 / 2);
      margin-right: calc(var(--grid-gutter) * -1 / 2);
      flex-wrap: wrap;
      display: flex;
    }

    $sizes: row, row-reverse, column, column-reverse;

    @each $size in $sizes {
      .direction-#{$size} {
        flex-direction: $size;
      }
    }

    @each $size in $sizes {
      .direction-md-#{$size} {
        @include breakpoint("small") {
          flex-direction: $size;
        }
      }
    }
  }
</style>
